(() => {
  const SECTION_SELECTOR = '.pasquini-marcas';

  const initPasquiniMarcas = (root) => {
    if (!root || root.dataset.swiperReady === 'true') return;
    if (typeof window.Swiper === 'undefined') return;

    const swiperEl = root.querySelector('.pasquini-marcas__swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    const enableLoop = root.dataset.loop === 'true' && slides.length > 1;
    const paginationEl = root.querySelector('.pasquini-marcas__pagination');
    const prevButtons = root.querySelectorAll('.pasquini-marcas__arrow--prev');
    const nextButtons = root.querySelectorAll('.pasquini-marcas__arrow--next');

    const swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 600,
      loop: enableLoop,
      autoHeight: true,
      watchOverflow: true,
      // Swiper's pagination module still runs its slideChange handlers even
      // when this is omitted/undefined, and crashes reading params.pagination.el.
      // Passing `false` explicitly disables the module instead.
      pagination:
        paginationEl && slides.length > 1
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
    });

    prevButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        swiper.slidePrev();
      });
    });

    nextButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        swiper.slideNext();
      });
    });

    root.dataset.swiperReady = 'true';
    root._pasquiniMarcasSwiper = swiper;
  };

  const initAll = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initPasquiniMarcas);
  };

  const waitForSwiper = (attempt = 0) => {
    if (typeof window.Swiper !== 'undefined') {
      initAll();
      return;
    }

    if (attempt > 40) return;
    window.setTimeout(() => waitForSwiper(attempt + 1), 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSwiper());
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot =
      event.target.querySelector?.(SECTION_SELECTOR) || event.target.closest?.(SECTION_SELECTOR);
    if (sectionRoot) {
      sectionRoot.dataset.swiperReady = 'false';
      waitForSwiper();
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionRoot =
      event.target.querySelector?.(SECTION_SELECTOR) || event.target.closest?.(SECTION_SELECTOR);
    if (sectionRoot?._pasquiniMarcasSwiper) {
      sectionRoot._pasquiniMarcasSwiper.destroy(true, true);
      delete sectionRoot._pasquiniMarcasSwiper;
      sectionRoot.dataset.swiperReady = 'false';
    }
  });
})();
